export type FmbSabilMatchBy = "self" | "hof";

export type FmbMatchedSabil = {
  id: string;
  sabilNo?: string | null;
  sabilType?: string | null;
  itsNo?: string | null;
  name?: string | null;
  matchedBy: FmbSabilMatchBy;
};

export type FmbSabilMatch = {
  hasMatch: boolean;
  hofItsNo?: string | null;
  sabils: FmbMatchedSabil[];
};

export function emptyFmbSabilMatch(): FmbSabilMatch {
  return { hasMatch: false, hofItsNo: null, sabils: [] };
}

/** Hash route for opening a sabil show page in a new tab. */
export function sabilShowHref(sabilId: string): string {
  return `#/sabilData/${encodeURIComponent(sabilId)}/show`;
}

export function formatSabilMatchByLabel(matchedBy: FmbSabilMatchBy): string {
  return matchedBy === "hof" ? "HOF" : "ITS";
}

export function formatSabilMatchLabel(match: FmbSabilMatch | null | undefined): string {
  if (!match?.hasMatch || !match.sabils?.length) {
    return "No";
  }
  const parts = match.sabils.map((sabil) => {
    const type = (sabil.sabilType || "Sabil").trim();
    const no = sabil.sabilNo?.trim();
    const base = no ? `${type} ${no}` : type;
    return `${base} (${formatSabilMatchByLabel(sabil.matchedBy)})`;
  });
  return parts.join(", ");
}

export function formatItsDirectoryLabel(inDirectory: boolean | null | undefined): string {
  if (inDirectory == null) return "—";
  return inDirectory ? "Yes" : "No";
}

export function buildFmbSabilMatchFromRows(params: {
  fmbItsNo: string;
  hofItsNo: string | null;
  sabilRows: Array<{
    id?: string;
    sabilNo?: string | null;
    sabilType?: string | null;
    itsNo?: string | null;
    name?: string | null;
  }>;
}): FmbSabilMatch {
  const fmbIts = params.fmbItsNo.trim();
  const hofIts = params.hofItsNo?.trim() || null;
  const seen = new Set<string>();
  const sabils: FmbMatchedSabil[] = [];

  for (const row of params.sabilRows) {
    const id = typeof row.id === "string" ? row.id : "";
    if (!id || seen.has(id)) continue;
    const itsNo = row.itsNo?.trim() || "";
    let matchedBy: FmbSabilMatchBy | null = null;
    if (itsNo && itsNo === fmbIts) {
      matchedBy = "self";
    } else if (hofIts && itsNo === hofIts) {
      matchedBy = "hof";
    }
    if (!matchedBy) continue;
    seen.add(id);
    sabils.push({
      id,
      sabilNo: row.sabilNo ?? null,
      sabilType: row.sabilType ?? null,
      itsNo: row.itsNo ?? null,
      name: row.name ?? null,
      matchedBy,
    });
  }

  return {
    hasMatch: sabils.length > 0,
    hofItsNo: hofIts && hofIts !== fmbIts ? hofIts : null,
    sabils,
  };
}
